export default __webpack_public_path__ + "static/media/Highlord's Blade.70e60720.jpg";